<if(input.shareModel.storeUrlId)>
    <str-social-share model=input.shareModel>
        <@placeholder>
            <button class="str-share-button" data-track=input.tracking aria-label=input.ariaLabel>
                <ebay-share-ios-16-icon/>
                <span class="str-share-button__text">${input.label}</span>
            </button>
        </@placeholder>
    </str-social-share>
</if>
